export default __webpack_public_path__ + "static/media/rescue-slots-ico.1283e372.svg";